
export default {
  name: 'SectionIntro',
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    filteredBoxes() {
      return this.data.boxes.filter((box) => {
        return box.headline && box.text
      })
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
